import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'

export default ({ value, facet }) => {
    const { toggleProductFilter } = useActions()

    return (
        <>
            <li
                // class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                class="ns-mobile-facet-filter ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                data-nosto-element="facet-setting">
                <label class="ns-checkbox ns-d-block ns-color-grey-dark">
                    {value.value}
                    <input
                        type="checkbox"
                        checked={value.selected}
                        onChange={(e) => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                    {/* <span class="ns-checkmark"></span> */}
                    <span class="ns-checkmark-mobile"></span>
                </label>
                {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-grey ns-background-grey-light ns-border-radius-3">
                    {value.count}
                </span> */}

            </li>
        </>
    )
}
